import { useLayoutEffect, useState } from 'react'
import moment from 'moment-timezone'

// Makes every moment() call parse and format in the given zone while the caller is mounted,
// and restores the browser zone on unmount. Returns true once the zone is applied so the
// caller can hold off rendering times until then.
export function useMomentTimeZone(timeZone: string | null): boolean {
  const [applied, setApplied] = useState<string | null>(null)

  useLayoutEffect(() => {
    if (!timeZone) {
      return
    }
    moment.tz.setDefault(timeZone)
    setApplied(timeZone)
    return () => {
      moment.tz.setDefault()
    }
  }, [timeZone])

  return timeZone !== null && applied === timeZone
}
